// Interfaces
import { IManagedPosition } from "@/Settings/types/QueueMapping/QueueMapping";

// MUI
import { Grid, Typography } from "@mui/material";

// Layouts
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";

interface IPositionsMultiSelectProps {
	positions: IManagedPosition[];
	selected: IManagedPosition[];
	loading: boolean;
	error: boolean;
	disabled: boolean;
	onPositionsChange: (selected: IManagedPosition[]) => void;
}

const PositionsMultiSelect = (props: IPositionsMultiSelectProps) => {
	const { positions, selected, loading, onPositionsChange, error, disabled } = props;

	return (
		<Grid item container direction={"column"} rowSpacing={2}>
			<Grid item>
				<Typography className="regular-montserrat-label fs-18">Positions</Typography>
			</Grid>
			<Grid item>
				<SmartSelector
					classes="!w-[253px]"
					multiple
					tagsVariant={"text"}
					showBy={"label"}
					selectBy={"label"}
					options={positions}
					selected={selected}
					inputProps={{
						placeholder: "Select a Position",
					}}
					listBoxProps={{
						sx: { maxHeight: "220px" },
					}}
					disabled={disabled}
					error={!disabled && error}
					hideTooltip={true}
					loading={loading}
					onChangeAction={(values) => onPositionsChange(values as IManagedPosition[])}
				/>
			</Grid>
		</Grid>
	);
};
export default PositionsMultiSelect;
